import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';
import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_COURSE_LOG_GET',
  GET_SUCCESS: 'STUDENT_COURSE_LOG_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_COURSE_LOG_GET_FAILURE',
};

export const get = actions.get(
  (studentCourseId, query) =>
    `${BASE_URL}/student-course-logs/${studentCourseId}/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
